import { Button, DataHeader, DataSource, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOfficePendingPayAdjustment extends Layout {
    buttonSplitAdjustment: Button;
    buttonViewCommissionsHistory: Button;
    dataheaderPayAdjustment: DataHeader;
    panelDetails: Panel;
    sourceOffPendingDeduct: DataSource;
    tabAccounting: Tab;
    tabComments: Tab;
    tabPayDetails: Tab;
    tabsetPayAdjustments: Tabset;
    textboxAmount: Textbox;
    textboxCheckNumber: Textbox;
    textboxCurrency: Textbox;
    textboxDeductCodeId: Textbox;
    textboxDeductionType: Textbox;
    textboxDescr: Textbox;
    textboxGlid: Textbox;
    textboxPayeeId: Textbox;
    textboxProcessStatus: Textbox;
    textboxRate: Textbox;
    textboxReferenceNo: Textbox;
    textboxShortDesc: Textbox;
    textboxStatus: Textbox;
    textboxTransactionDate: Textbox;
    textboxUnits: Textbox;
}
